import { render, staticRenderFns } from "./partners-detail.vue?vue&type=template&id=4cd0d99a&scoped=true&"
import script from "./partners-detail.vue?vue&type=script&lang=js&"
export * from "./partners-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd0d99a",
  null
  
)

export default component.exports